import React from 'react';
import { Portfolio } from '../../services/portfolio';
import { usePrivacy } from '../../contexts/PrivacyContext';
import { useCurrency } from '../../contexts/CurrencyContext';

interface PortfolioHeaderProps {
  portfolio: Portfolio;
  totalPortfolioValue: number;
}

const PortfolioHeader: React.FC<PortfolioHeaderProps> = ({ portfolio, totalPortfolioValue }) => {
  const { isPrivateMode } = usePrivacy();
  const { formatAmount } = useCurrency();

  const formatLastSyncTime = () => {
    if (portfolio.last_etf_sync_at) {
      return new Date(portfolio.last_etf_sync_at).toLocaleDateString();
    }
    return 'Never';
  };

  return (
    <div className="mb-4 pb-4" style={{ borderBottom: '1px solid #f4f4f5' }}>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-end gap-2">
        <div>
          <h1 className="fw-semibold mb-1" style={{ color: '#000537', letterSpacing: '-0.025em' }}>
            {portfolio.name}
          </h1>
          <div style={{ fontSize: '0.75rem', color: '#a1a1aa' }}>
            Last sync: {formatLastSyncTime()}
          </div>
        </div>
        <div className="text-md-end">
          <div className="fw-semibold" style={{ fontSize: '1.5rem', color: '#000537', letterSpacing: '-0.02em' }}>
            {formatAmount(totalPortfolioValue, isPrivateMode)}
          </div>
          <div style={{ fontSize: '0.75rem', color: '#a1a1aa' }}>total value</div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioHeader;
